import { render, staticRenderFns } from "./Indicator.vue?vue&type=template&id=47b48ace"
import script from "./Indicator.vue?vue&type=script&lang=ts"
export * from "./Indicator.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports